module.exports = __webpack_public_path__ + "media/images/icons/map/marker-passenger-check-in-1ae0e9e824d8c8f1123c1a941964e96a.svg";